import React from "react";
import { withTranslation } from "react-i18next";
import { ROUTER_PATH } from "../../common/constant";
import TopicItem from "../../components/topicItem";
import { IPageNotFoundProps } from "../../models/interface/IPageNotFoundProps";
import { common } from "../../services";
import { localizeRouteKey } from "../../shared/helpers";
import "./style.scss";

const Topic = ({ match, history }: IPageNotFoundProps) => {
  const [banner, setBanner] = React.useState<any>([]);

  React.useEffect(() => {
    common.getBanner("HOME", { id: match.params.id }, (data: any, err: any) => {
      if (data && data.length && data[0].banners.length) {
        setBanner(data[0].banners);
      } else {
        history.replace(localizeRouteKey(ROUTER_PATH.HOME));
      }
    });
  }, [match.url]);

  return banner.length ? (
    <div>
      <TopicItem banner={banner[0]} />
    </div>
  ) : null;
};

export default withTranslation()(Topic);
